import React, { Component } from 'react';

import { ComposedChart, Bar, XAxis, Tooltip, Cell, YAxis, ResponsiveContainer, Line } from 'recharts';

import './topStyle.css';

import GenericTooltip from '../GenericTooltip';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../../../Actions/Dashboard';

class TopComponent extends Component {
  domain = () => {
    if (this.props.data.length === 0)
      return [0, 0];
    let resp = this.props.data.reduce((acum, data) => {
      if (acum[this.props.dataKey] < data[this.props.dataKey])
        return data;
      return acum;
    })
    return [0, (parseInt(resp[this.props.dataKey] * 1.2) + 1)];
  }

  render() {
    return (
      <ResponsiveContainer>
        <ComposedChart width={400} height={250} data={this.props.data}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          style={{ margin: 'auto' }} >
          <XAxis ticks={['']} />
          <YAxis fontSize={12} allowDecimals={false} domain={this.domain()} />
          <Tooltip content={
            <GenericTooltip
              data={this.props.data}
              colors={this.props.colors}
            />}
          />
          <Bar dataKey={this.props.dataKey} fill="#006290" label={{ position: 'top', fontSize: 14 }}>
            {
              this.props.data.map((entry, index) => (
                <Cell key={'cell-bars-' + this.props.name + index} fill={this.props.colors[index % this.props.colors.length]} />
                // <Cell key={'cell-bars-' + this.props.name + index} fill={this.props.colors[index % this.props.colors.length]} />
              ))
            }
          </Bar>
          <Line type="monotone" dataKey={this.props.lineKey} stroke="#8884d8" />
        </ComposedChart>
      </ResponsiveContainer>
    )
  }
}

function mapDispathToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

export default connect(null, mapDispathToProps)(TopComponent);